import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface AttachmentsImageDialogData {
  url: string;
  name: string;
}

@Component({
  selector: "app-attachments-image-dialog",
  templateUrl: "./attachments-image-dialog.component.html",
  styleUrls: ["./attachments-image-dialog.component.scss"],
  standalone: false,
})
export class AttachmentsImageDialogComponent {
  data = inject<AttachmentsImageDialogData>(MAT_DIALOG_DATA);
}
